module.exports = __webpack_public_path__ + "img/71.5afa9eb3.jpg";